import React, {Component} from 'react';

class NotificationStatus extends Component {
	render() {		
		return <select {...this.props}>
			<option value="">--- Estatus ---</option>
			<option value="success" className="has-text-success">Correcto</option>
			<option value="danger" className="has-text-danger">Incorrecto</option>
			<option value="warning" className="has-text-warning">Observación</option>
			<option value="info" className="has-text-info">Comentario</option>
		</select>;
	}
}

export default NotificationStatus;


// WEBPACK FOOTER //
// ./src/elements/forms/notification_status.jsx